export default __webpack_public_path__ + "static/media/box.a7eb9bc7.svg";